( function($) {
	/**
	 * Inject + edit member information in popup modal
	 */
	$( '.edit a' ).on( 'click', function(e) {
		e.preventDefault();

		let member 			= $( this ).closest( 'tr' );
		let memberUrl 	= member.find( '.member a' ).attr( 'href' );
		let name 				= member.find( '.member' ).text();
		let role 				= member.find( '.role' ).text();
		let id 					= member.find( '.id' ).text();
		let companyId		= member.find( '.companyId' ).text();
		let customerId	= member.find( '.customerId' ).text();
		let dailyHTML   = member.find( '.daily' ).html();
		let dailyValue  = dailyHTML.replace( /\D/g, '' ); // strip all but numbers from string
		let weeklyHTML  = member.find( '.weekly' ).html();
		let weeklyValue = weeklyHTML.replace( /\D/g, '' ); // strip all but numbers from string		
		let orderHTML   = member.find( '.order' ).html();
		let orderValue  = orderHTML.replace( /\D/g, '' ); // strip all but numbers from string

		name = $.trim( name );

		$( '#name' ).text( name );
		$( '#memberUrl' ).attr( 'href', memberUrl );
		$( '#role' ).text( role );
		$( 'input[name="portal_member_name"]' ).val( name );
		$( 'input[name="portal_member_id"]' ).val( id );
		$( 'input[name="portal_member_company_id"]' ).val( companyId );
		$( 'input[name="portal_member_customer_id"]' ).val( customerId );
		$( '#dlimit' ).val( dailyValue );
		$( '#wlimit' ).val( weeklyValue );
		$( '#olimit' ).val( orderValue );
	} );
} )( jQuery );
